import { createSlice } from "@reduxjs/toolkit";

export const userProfileSlice = createSlice({
  name: "userProfile",
  initialState: {
    changeStatusForm: {
      status: "-1",
      message1: "",
      message2: "",
    },
    userData: {},
    packageHistory: [],
    idStatusList: [
      "Unverified",
      "Verified",
      "Pending verification",
      "Rejected",
    ],
    statusHistory: [],
  },
  reducers: {
    handleChangeStatusReducer: (state, actions) => {
      const { name, value } = actions.payload;
      let tempForm = { ...state.changeStatusForm };
      tempForm[name] = value;
      state.changeStatusForm = tempForm;
    },
    setUserDataReducer: (state, actions) => {
      state.userData = actions.payload;
    },
    getUserPackageHistoryInTheLastTenDays: (state, actions) => {
      state.packageHistory = actions.payload;
    },
    getUserStatusHistory: (state, actions) => {
      state.statusHistory = actions.payload;
    },
  },
});

export const {
  handleChangeStatusReducer,
  setUserDataReducer,
  getUserPackageHistoryInTheLastTenDays,
  getUserStatusHistory,
} = userProfileSlice.actions;

export default userProfileSlice.reducer;
